<template>
    <form @submit.prevent="personWorkInfo_Submit">
        <div class="card">
            <div class="card-header">
                个人工作信息管理
            </div>
            <div class="card-body">
                <div class="form-group row">
                    <label class="col-sm-2 col-form-label text-right" for="inputPost">职务</label>
                    <div class="col-sm-4">
                        <input type="text" class="form-control" id="inputPost" v-model="personWorkInfo.post">
                    </div>
                    <label class="col-sm-2 col-form-label text-right" for="inputTitle">职称</label>
                    <div class="col-sm-4">
                        <input type="text" class="form-control" id="inputTitle" v-model="personWorkInfo.title">
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-2 col-form-label text-right" for="inputDepartmentName">院系/部门</label>
                    <div class="col-sm-10">
                        <input type="text" class="form-control" id="inputDepartmentName" v-model="personWorkInfo.departmentName">
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-2 col-form-label text-right" for="inputDegreeField">研究领域</label>
                    <div class="col-sm-10">
                        <input type="text" class="form-control" id="inputDegreeField" v-model="personWorkInfo.degreeField">
                    </div>
                </div>
                <div class="form-group row mb-0">
                    <label class="col-sm-2 col-form-label text-right" for="inputWorkYear">工作职责</label>
                    <div class="col-sm-10">
                        <input type="text" class="form-control" id="inputWorkYear" v-model="personWorkInfo.dutyDescription">
                    </div>
                </div>
            </div>
            <div class="card-footer text-center">
                <button class="btn btn-primary" type="submit">保存</button>
            </div>
        </div>
    </form>
</template>

<script>
import userApi from "@/utils/api/user";
export default {
    name: "OrganPersonWorkInfoEdit",
    props: {
        personId: {type: String, required: true},
    },
    data: function () {
        return {
            personWorkInfo: {},
            queryInfo: {
                personId: '',
                userType: localStorage.getItem("userType"),
            }
        };
    },
    mounted() {
        this.getPersonWorkInfo();
    },
    methods: {
        getPersonWorkInfo() {
            userApi.person.work.getOrganWorkInfo(this.personId).then(res => {
                this.personWorkInfo = res.data;
            });
        },

        personWorkInfo_Submit() {
            userApi.person.work.updateOrganWorkInfo(this.personWorkInfo).then(res => {
                this.personWorkInfo = res.data;
                alert('工作信息已保存！');
            })
        }
    }
}
</script>

<style scoped>

</style>